import React from "react";
import { PawPrint } from "lucide-react";
import { motion } from "framer-motion";

const IconList = ({ items }) => {
  return (
    <ul className="icon-list">
      {items.map((item, index) => (
        <motion.li
          key={index}
          className="icon-list-item"
          initial={{ opacity: 0, y: 50 }} // Fade in from below
          whileInView={{ opacity: 1, y: 0 }} // Fade in and slide up when in view
          transition={{ duration: 0.6, delay: index * 0.5 }} // Delay each item by 0.5s
          viewport={{ once: true }} // Only animate once
        >
          <PawPrint />
          <span>
            <b>{item.title}</b> <br />
            <p className="texts py-2">{item.text}</p>
          </span>
        </motion.li>
      ))}
    </ul>
  );
};

export default IconList;
